import React from 'react';


export default class item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        return (
            <div className="marker">
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/cafe-haiti/mapa/item.js